<template>
  <div id="stories-list">
    <particle-wave :particle-size="9" :number-of-particles="600" :r="255" :g="255" :b="255" />
    <div class="content">
      <div class="wrapper">
        <h1>{{ t('XOI_STORIES') }}</h1>

        <div class="list" ref="listRef">
          <div class="row">
            <div
              class="col col-xs-12 col-md-6 col-lg-4"
              v-for="(col, i) in itemsGrid"
              :key="i"
            >
              <div
                v-for="item in itemsGrid[i]"
                :key="item.id"
                class="item"
              >
                <div class="box">
                  <router-link :to="applyParams(PATHS.STORY_PIECE, item.slug)">
                    <h3>{{ item.title }}</h3>
                    <div class="img-holder" v-if="!!item.image">
                      <img :src="item.image.url" :alt="item.title" />
                    </div>
                  </router-link>
                  <p>{{ item.description }}</p>
                  <div class="date">{{ moment(item.createdAt).format(`${locale === 'en' ? 'DD MMM, YYYY' : 'DD [tháng] MM, YYYY'}`) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMeta } from 'vue-meta';
import { useStore } from 'vuex';
import moment from 'moment';

import ParticleWave from '@/components/ParticleWave';

import PATHS from '@/consts/paths';
import { applyParams } from '@/helpers';

export default {
  name: 'StoriesList',
  components: {
    ParticleWave
  },
  setup() {
    const { t, locale } = useI18n();
    const store = useStore();

    const listRef = ref(null);
    const filters = computed(() => store.state.stories.filters);
    const isLoggedIn = computed(() => store.getters['user/isLoggedIn']);

    const title = t('XOI_STORIES');

    const { meta } = useMeta({
      title,
      og: {
        title: `${title} | XOI`
      },
    });

    watch(locale, () => {
      meta.title = t('XOI_STORIES');
    });

    const calculateItemHeightScore = (item) => {
      let h = 0;
      if (item?.image) h += 300;
      if (item?.description) h += item.description.length;

      return h;
    };

    const items = computed(() => store.state.stories.items);
    const itemsGrid = computed(() => {
      let n = 3;
      if (store.state.app.isTablet) {
        n = 2;
      } else if (store.state.app.isMobile) {
        n = 1;
      }

      const stacks = Array(n).fill().map(() => []);
      const stackHeights = Array(n).fill(0);

      for (let i = 0; i < items.value.length; i += 1) {
        const minStack = stackHeights.indexOf(Math.min(...stackHeights));
        stacks[minStack].push({ ...items.value[i] });
        stackHeights[minStack] += calculateItemHeightScore(items.value[i]);
      }

      return stacks;
    });

    watch(filters, () => {
      store.dispatch('stories/getStories', { append: false });
    });

    watch(isLoggedIn, (val) => {
      if (!val) return;
      store.dispatch('stories/getStories', { append: false });
    }, {
      immediate: true
    });

    return {
      t,
      itemsGrid,
      PATHS,
      applyParams,
      moment,
      locale,
      listRef
    };
  }
};
</script>

<style lang="scss">
@use "~@/assets/scss/colors" as *;
@use "~@/assets/scss/dimens" as *;

#stories-list {
  #particle-wave {
    position: fixed;
    top: $headerHeight;
    left: 0;
    width: 100%;
    height: calc(100vh - #{$footerHeight} - #{$headerHeight});

    canvas {
      background-color: $black;
    }
  }

  .content {
    .wrapper {
      max-width: 960px;
      background: none;
    }

    .list {
      margin-top: 50px;

      .item {
        .box {
          background-color: $white;
        }
      }
    }
  }
}
</style>
